import { apiConfig } from 'core-lib/config/config';
import { MethodData } from '../types/Model';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { serializeMethod } from './fetchMethodList';

type ResultTypes = {
  response?: MethodData;
  error?: any;
};

const fetchLastUsed = async (body: any,amount:number): Promise<ResultTypes> => {
  const url = `${apiConfig('payment')}/latest/payments/last/payment-method`;
  const headers = getDefaultHeaders({
    deviceOs: true,
    deviceId: true,
    effectivePlatform: true,
    nativeAppVersion: false,
    packageName: true,
  });
  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers,
  });
  if (response) {
    if (response?.data) {
      return { response: await serializeMethod(response.data,amount) };
    } else return { error: {} };
  }
  if (error) {
    return { error };
  }
};

export default fetchLastUsed;
